import gql from 'graphql-tag';
import React from 'react';
import { useState } from 'react';
import { Fragment } from 'react';
import { withApollo } from 'react-apollo';
import PhoneInput from 'react-phone-input-2';
import { useHistory, useLocation } from 'react-router';
import callIcon from '../../images/callrequest-icon.svg';
import callCancelledIcon from '../../images/request-cancelled.svg';
import TorontoFooter from '../Layout/TorontoFooter';
import Dropdown from '../shared/Dropdown';
import SFFooter from '../Layout/SFFooter';
import OttawaFooter from '../Layout/OttawaFooter';
import NYCFooter from '../Layout/NYCFooter';

const ContactCallRequest = ({ client }) => {
  const [isCancell, setIsCancell] = useState();
  const [isRequested, setIsRequested] = useState();
  const [curFirst, setCurFirst] = useState();
  const [curLast, setCurLast] = useState();
  const [curPhone, setCurPhone] = useState();
  const [curEmail, setCurEmail] = useState();
  const [ticket, setTicket] = useState();
  const [call, setCall] = useState();
  const [toSubmit, setToSubmit] = useState();
  const [curDrive, setCurDrive] = useState();

  const history = useHistory();
  const pathname = history.location.pathname;

  const allCityOptions = [
    { name: 'Toronto', value: 'toronto' },
    { name: 'New York', value: 'new_york' },
    { name: 'San Francisco', value: 'san_francisco' },
    { name: 'Los Angeles', value: 'los_angeles' },
    { name: 'Ottawa', value: 'ottawa'}
  ];

  const triggerDriveCity = childData => {
    setCurDrive(childData);
  };

  const toggleCancell = () => {
    setIsCancell(!isCancell);
  };

  const toggleRequested = () => {
    setIsRequested(!isRequested);
  };

  const triggerFirst = e => {
    setCurFirst(e.target.value);
  };

  const triggerLast = e => {
    setCurLast(e.target.value);
  };

  const triggerPhone = e => {
    setCurPhone(e);
  };

  const triggerEmail = e => {
    setCurEmail(e.target.value);
  };

  const toggleToSubmit = () => {
    setToSubmit(!toSubmit);
  };

  const CREATE_TICKET = gql`
    mutation CallRequestCallback(
      $userId: ID
      $firstName: String
      $lastName: String
      $mobile: String
      $email: String
      $operatingCity: String
    ) {
      callRequestCallback(
        userId: $userId
        firstName: $firstName
        lastName: $lastName
        mobile: $mobile
        email: $email
        operatingCity: $operatingCity
      ) {
        ticket {
          id
        }
        error
      }
    }
  `;

  const CALL_REQUEST = gql`
    mutation StartCallRequest($ticketId: ID!) {
      startCallRequest(ticketId: $ticketId) {
        callRequest {
          id
        }
        success
        error
      }
    }
  `;

  const handleCallRequest = ticketId => {
    // e.preventDefault();
    client
      .mutate({
        mutation: CALL_REQUEST,
        variables: {
          ticketId: ticketId
        }
      })
      .then(res => {
        if (res.data.startCallRequest.success) {
          setCall(res.data.startCallRequest.callRequest.id);
          console.log('Call requested');
        }
      });
  };

  const handleCreateTicket = e => {
    // e.preventDefault();
    client
      .mutate({
        mutation: CREATE_TICKET,
        variables: {
          userId: null,
          firstName: curFirst,
          lastName: curLast,
          mobile: curPhone.substr(curPhone.length - 10),
          email: curEmail,
          operatingCity: curDrive
        }
      })
      .then(res => {
        if (!res.data.callRequestCallback.error) {
          handleCallRequest(res.data.callRequestCallback.ticket.id);
          setTicket(res.data.callRequestCallback.ticket.id);
          console.log('Ticket created, starting a call request...');
        }
      });
  };

  const isMobile = window.innerWidth < 768;
  const ableToRequest = curFirst && curLast && curPhone && curEmail && curDrive;
  const emailInvalid = !(curEmail && curEmail.includes('@'));
  const cityInvalid = !(curDrive);

  return (
    <Fragment>
      {isRequested ? (
        isCancell ? (
          <div
            className="signup-form-container"
            style={{ alignItems: 'center' }}>
            <img src={callCancelledIcon} />
          </div>
        ) : (
          <div
            className="signup-form-container"
            style={{ alignItems: 'center' }}>
            <img
              src={callIcon}
              style={{ width: '72px', marginBottom: '36px' }}
            />
            <div className="form-title" style={{ fontSize: '40px' }}>
              Sit tight...
            </div>
            <div
              className="download-description"
              style={{
                fontSize: isMobile ? '16px' : '20px',
                margin: '24px 0 56px 0'
              }}>
              Our team has received your call request. We will call you
              soon.
            </div>
          </div>
        )
      ) : (
        <div className="signup-form-container">
          <div className="form-title">Request a call</div>
          <div className="input-field">
            <div className="floating-label">First name</div>
            <input
              className="input-container"
              onChange={triggerFirst}></input>
          </div>
          <div className="input-field">
            <div className="floating-label">Last name</div>
            <input
              className="input-container"
              onChange={triggerLast}></input>
          </div>
          <div className="floating-label">Phone number</div>
          <PhoneInput
            value={curPhone}
            onChange={triggerPhone}
            country={pathname.includes('tor') ? 'ca' : 'us'}
            className="input-field-phone"
            inputStyle={{
              height: '40px',
              width: '100%',
              border: '1px solid #dedede'
            }}
          />
          <div className="input-field">
            <div className="floating-label">Email</div>
            <input
              className="input-container"
              onChange={triggerEmail}></input>
            {toSubmit && emailInvalid && (
              <span style={{ color: '#ff0000' }}>
                Invalid email address
              </span>
            )}
          </div>
          <div className="input-field">
            <div className="floating-label">City</div>
            <Dropdown
              initialValue={curDrive}
              items={allCityOptions}
              onChange={triggerDriveCity}
              width={isMobile ? '327px' : '600px'}
              height="40px"
              optionWidth={isMobile ? '327px' : '600px'}
              borderColor={'#dedede'}
            />
            {toSubmit && cityInvalid && (
              <span style={{ color: '#ff0000' }}>
                Choose a city
              </span>
            )}
          </div>
          <button
            className={
              ableToRequest ? 'signup-button' : 'signup-button-invalid'
            }
            onClick={() => {
              toggleToSubmit();
              ableToRequest && !emailInvalid && handleCreateTicket();
              ableToRequest && !emailInvalid && toggleRequested();
            }}>
            Request
          </button>
        </div>
      )}
      {pathname.includes('tor') ? (
        <TorontoFooter />
      ) : pathname.includes('sf') ? (
        <SFFooter />
      ) : pathname.includes('ott') ? (
        <OttawaFooter />
      ) : (
        <NYCFooter />
      )}
    </Fragment>
  );
};

export default withApollo(ContactCallRequest);



// WEBPACK FOOTER //
// ./src/components/NewContact/ContactCallRequest.js